import React from 'react';

interface StepNumberIconProps {
  displayNumber: number;
}

const StepNumberIcon: React.FC<StepNumberIconProps> = ({ displayNumber }) => (
  <div className="relative">
    <div className="bg-black text-white text-sm rounded-full w-6 h-6 flex items-center justify-center font-bold">
      {displayNumber}
    </div>
  </div>
);

export default StepNumberIcon; 